const actionLogger = () => store => next => action => {
  const prevState = store.getState();
  const result = next(action);
  const nextState = store.getState();
  console.info(`${action.type}`);
  console.info('%cprev state', 'color: orange', prevState);
  console.info('%caction payload', 'color: aqua', action.payload);
  console.info('%cnext state', 'color: lime', nextState);

  return result;
};
export default actionLogger;



// WEBPACK FOOTER //
// ./src/state/middleware/actionLogger.js